import React from 'react';
import { useNavigate } from 'react-router-dom';
import ReturnPolicy from '../components/ReturnPolicy';

const ReturnPolicyPage = () => {
  const navigate = useNavigate();
  return <ReturnPolicy onBack={() => navigate(-1)} />;
};

export default ReturnPolicyPage;
